import { useMediaQuery } from "@mui/material";

export const useResponsiveStyles = () => {
    const isSmall = useMediaQuery("(min-width: 600px)");
    const isMedium = useMediaQuery("(min-width: 768px)");
    const isLarge = useMediaQuery("(min-width: 1024px)");
    const isXLarge = useMediaQuery("(min-width: 1280px)");
    const isXSLarge = useMediaQuery("(min-width: 1450px)");
    const isXXLarge = useMediaQuery("(min-width: 1600px)");
    const is4K = useMediaQuery("(min-width: 3840px)");

    const getFontSize = (type) => {
        switch (type) {
            case "side-bar-heading":
                if (is4K) return { fontSize: "20px" };
                if (isXXLarge) return { fontSize: "16px" };
                if (isXLarge) return { fontSize: "12px" };
                if (isLarge) return { fontSize: "12px" };
                if (isMedium) return { fontSize: "12px" };
                if (isSmall) return { fontSize: "13px" };
                return { fontSize: "12px" }; // Default
            case "heading":
                if (is4K) return { fontSize: "24px" };
                if (isXXLarge) return { fontSize: "22px" };
                if (isXLarge) return { fontSize: "16px" };
                if (isLarge) return { fontSize: "14px" };
                if (isMedium) return { fontSize: "12px" };
                if (isSmall) return { fontSize: "13px" };
                return { fontSize: "12px" }; // Default
            case "sub-heading":
                if (is4K) return { fontSize: "22px" };
                if (isXXLarge) return { fontSize: "20px" };
                if (isXSLarge) return { fontSize: "14px" };
                if (isXLarge) return { fontSize: "14px" };
                if (isLarge) return { fontSize: "15px" };
                if (isMedium) return { fontSize: "12px" };
                if (isSmall) return { fontSize: "13px" };
                return { fontSize: "12px" }; // Default
            case "body1":
                if (is4K) return { fontSize: "18px" };
                if (isXXLarge) return { fontSize: "16px" };
                if (isXSLarge) return { fontSize: "14px" };
                if (isXLarge) return { fontSize: "10px" };
                if (isLarge) return { fontSize: "10px" };
                if (isMedium) return { fontSize: "10px" };
                if (isSmall) return { fontSize: "10px" };
                return { fontSize: "12px" }; // Default
            case "chart":
                if (is4K) return { fontSize: "22px" };
                if (isXXLarge) return { fontSize: "20px" };
                if (isXLarge) return { fontSize: "14px" };
                if (isLarge) return { fontSize: "12px" };
                if (isMedium) return { fontSize: "10px" };
                if (isSmall) return { fontSize: "10px" };
                return { fontSize: "12px" }; // Default
            case "stat":
                if (is4K) return { fontSize: "28px" };
                if (isXXLarge) return { fontSize: "22px" };
                if (isXLarge) return { fontSize: "16px" };
                if (isLarge) return { fontSize: "12px" };
                if (isMedium) return { fontSize: "12px" };
                if (isSmall) return { fontSize: "12px" };
                return { fontSize: "12px" }; // Default
            case "identity-card-name":
                if (is4K) return { fontSize: "25px" };
                if (isXXLarge) return { fontSize: "20px" };
                if (isXLarge) return { fontSize: "14px" };
                if (isLarge) return { fontSize: "10px" };
                if (isMedium) return { fontSize: "10px" };
                if (isSmall) return { fontSize: "10px" };
                return { fontSize: "14px" }; // Default

            case "client-rank":
                if (is4K) return { fontSize: "35px" };
                if (isXXLarge) return { fontSize: "30px" };
                if (isXLarge) return { fontSize: "26px" };
                if (isLarge) return { fontSize: "24px" };
                if (isMedium) return { fontSize: "10px" };
                if (isSmall) return { fontSize: "10px" };
                return { fontSize: "14px" }; // Default
            case "identity-card-info":
                if (is4K) return { fontSize: "25px" };
                if (isXXLarge) return { fontSize: "14px" };
                if (isXLarge) return { fontSize: "10px" };
                if (isLarge) return { fontSize: "10px" };
                if (isMedium) return { fontSize: "10px" };
                if (isSmall) return { fontSize: "10px" };
                return { fontSize: "14px" }; // Default
            default:
                return { fontSize: "14px" }; // Default
        }
    };

    const getContainerWidth = (type) => {
        switch (type) {
            case "side-bar-width":
                if (is4K) return 250;
                if (isXXLarge) return 230;
                if (isXLarge) return 180;
                if (isLarge) return 180;
                if (isMedium) return 180;
                if (isSmall) return 180;
                return 200;
            case "filter-panel":
                if (is4K) return { width: "450px" };
                if (isXXLarge) return { width: "450px" };
                if (isXLarge) return { width: "320px" };
                if (isLarge) return { width: "320px" };
                if (isMedium) return { width: "320px" };
                if (isSmall) return { width: "320px" };
                return { width: "320px" };
            default:
                return 200; // Default
        }
    };

    const getContainerHeight = (type) => {
        switch (type) {
            case "tab-container":
                if (is4K) return { height: "35px" };
                if (isXXLarge) return { height: "33px" };
                if (isXLarge) return { height: "30px" };
                if (isLarge) return { height: "25px" };
                if (isMedium) return { height: "25px" };
                if (isSmall) return { height: "25px" };
                return { height: "30px" };
            case "tab-height":
                if (is4K) return { height: "32px", minHeight: "32px" };
                if (isXXLarge) return { height: "30px", minHeight: "30px" };
                if (isXLarge) return { height: "28px", minHeight: "28px" };
                if (isLarge) return { height: "23px", minHeight: "23px" };
                if (isMedium) return { height: "24px", minHeight: "24px" };
                if (isSmall) return { height: "24px", minHeight: "24px" };
                return { height: "24px", minHeight: "24px" };
            case "filter-height":
                if (is4K) return { height: "38px" };
                if (isXXLarge) return { height: "32px" };
                if (isXLarge) return { height: "27px" };
                if (isLarge) return { height: "23px" };
                if (isMedium) return { height: "24px" };
                if (isSmall) return { height: "24px" };
                return { height: "24px" };

            case "filter-container":
                if (is4K) return { height: "250px" };
                if (isXXLarge) return { height: "230px" };
                if (isXLarge) return { height: "200px" };
                if (isLarge) return { height: "200px" };
                if (isMedium) return { height: "180px" };
                if (isSmall) return { height: "180px" };
                return { height: "180px" };
            case "sectorial-paper":
                if (is4K) return { height: "400px" };
                if (isXXLarge) return { height: "336px" };
                if (isXSLarge) return { height: "301px" };
                if (isXLarge) return { height: "290px" };
                if (isLarge) return { height: "280px" };
                if (isMedium) return { height: "280px" };
                if (isSmall) return { height: "280px" };
                return { height: "280px" };
            case "coverage-universe":
                if (is4K) return { height: "65vh" };
                if (isXXLarge) return { height: "42vh" };
                if (isXSLarge) return { height: "50vh" };
                if (isXLarge) return { height: "60vh" };
                if (isLarge) return { height: "65vh" };
                if (isMedium) return { height: "65vh" };
                if (isSmall) return { height: "65vh" };
                return { height: "65vh" };
            default:
                return { height: "30px" };
        }
    };

    const getIconSize = (type) => {
        switch (type) {
            case "side-bar-icon":
                if (is4K) return { height: "30px", width: "30px" };
                if (isXXLarge) return { height: "30px", width: "30px" };
                if (isXLarge) return { height: "22px", width: "22px" };
                if (isLarge) return { height: "18px", width: "18px" };
                if (isMedium) return { height: "16px", width: "16px" };
                if (isSmall) return { height: "16px", width: "16px" };
                return { height: "18px", width: "18px" };
            case "toggle-icon":
                if (is4K) return { height: "30px", width: "30px" };
                if (isXXLarge) return { height: 25, width: 24, top: 52 };
                if (isXLarge) return { height: 18, width: 22, top: 52 };
                if (isLarge) return { height: 18, width: 22, top: 52 };
                if (isMedium) return { height: 18, width: 22, top: 52 };
                if (isSmall) return { height: 18, width: 22, top: 52 };
                return { height: 18, width: 22, top: 52 };
            default:
                return { height: "18px", width: "18px" }; // Default
        }
    };

    const getButtonStyle = (type) => {
        switch (type) {
            case "filter-button":
                if (is4K) return { height: "28px", fontSize: "16px" };
                if (isXXLarge) return { height: "28px", fontSize: "16px" };
                if (isXLarge) return { height: "23px", fontSize: "14px" };
                if (isLarge) return { height: "23px", fontSize: "12px" };
                if (isMedium) return { height: "24px", fontSize: "24px" };
                if (isSmall) return { height: "24px", fontSize: "24px" };
                return { height: "24px", fontSize: "24px" };

            case "filter-action-button":
                if (is4K) return { height: "38px", width: "120px" };
                if (isXXLarge) return { height: "38px", width: "120px" };
                if (isXLarge) return { height: "25px", width: "90px" };
                if (isLarge) return { height: "25px", width: "90px" };
                if (isMedium) return { height: "25px", width: "90px" };
                if (isSmall) return { height: "25px", width: "90px" };
                return { height: "25px", width: "90px" };

            case "create-button":
                if (is4K) return { height: "38px", fontWeight: 500 };
                if (isXXLarge) return { height: "32px", fontWeight: 500 };
                if (isXLarge) return { height: "27px", fontWeight: 500 };
                if (isLarge) return { height: "23px", fontWeight: 500 };
                if (isMedium) return { height: "24px", fontWeight: 500 };
                if (isSmall) return { height: "24px", fontWeight: 500 };
                return { height: "24px", fontWeight: 500 };

            default:
                return { height: "32px", fontSize: "80px" };
        }
    };

    const getSectionStyle = (type) => {
        switch (type) {
            case "identity-card-image":
                if (is4K) return { height: 80, fontSize: "4rem", width: 80 };
                if (isXXLarge)
                    return { height: 90, fontSize: "4rem", width: 90 };
                if (isLarge) return { height: 65, fontSize: "3rem", width: 65 };
                if (isMedium)
                    return { height: 60, fontSize: "3rem", width: 60 };
                if (isSmall) return { height: 60, fontSize: "3rem", width: 60 };
                return { height: 60, fontSize: "3rem", width: 60 };

            case "client-revenue-section":
                if (is4K)
                    return {
                        paddingRight: "15px",
                        paddingLeft: "15px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                    };
                if (isXXLarge)
                    return {
                        paddingRight: "15px",
                        paddingLeft: "15px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                    };
                if (isLarge)
                    return {
                        paddingRight: "10px",
                        paddingLeft: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                    };
                if (isMedium)
                    return {
                        paddingRight: "10px",
                        paddingLeft: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                    };
                if (isSmall)
                    return {
                        paddingRight: "10px",
                        paddingLeft: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                    };
                return {
                    paddingRight: "10px",
                    paddingLeft: "10px",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                };

            case "report":
                if (is4K) return { padding: "0.25rem" };
                if (isXXLarge) return { padding: "0.25rem" };
                if (isXLarge)
                    return { paddingTop: "0.20rem", paddingBottom: "0.25rem" };
                if (isLarge) return { padding: "0.16rem" };
                if (isMedium) return { padding: "0.16rem" };
                if (isSmall) return { padding: "0.16rem" };
                return { padding: "0.25rem" };

            case "stats":
                if (is4K) return { height: "38px", width: "120px" };
                if (isXXLarge) return { height: "38px", width: "120px" };
                if (isXLarge) return { height: "25px", width: "90px" };
                if (isLarge) return { height: "25px", width: "90px" };
                if (isMedium) return { height: "25px", width: "90px" };
                if (isSmall) return { height: "25px", width: "90px" };
                return { height: "25px", width: "90px" };
            case "filter-section":
                if (is4K) return { marginRight: "10px" };
                if (isXXLarge) return { marginRight: "-5px" };
                if (isXSLarge) return { marginRight: "-5px" };
                if (isXLarge) return { marginRight: "6px" };
                if (isLarge) return { marginRight: "10px" };
                if (isMedium) return { marginRight: "10px" };
                if (isSmall) return { marginRight: "10px" };
                return { marginRight: "10px" };
            case "avatar":
                if (is4K) return { height: "50px", width: "50px" };
                if (isXXLarge) return { height: "40px", width: "40px" };
                if (isXLarge) return { height: "30px", width: "30px" };
                if (isLarge) return { height: "25px", width: "25px" };
                if (isMedium) return { height: "25px", width: "25px" };
                if (isSmall) return { height: "25px", width: "25px" };
                return { height: "25px", width: "25px" };
            case "action-button":
                if (is4K) return { height: "50px", width: "50px" };
                if (isXXLarge) return { height: "60px", width: "60px" };
                if (isXSLarge) return { height: "45px", width: "45px" };
                if (isXLarge) return { height: "40px", width: "40px" };
                if (isLarge) return { height: "45px", width: "45px" };
                if (isMedium) return { height: "45px", width: "45px" };
                if (isSmall) return { height: "45px", width: "45px" };
                return { height: "45px", width: "45px" };
            case "description-box":
                if (is4K) return { height: "50px", width: "50px" };
                if (isXXLarge) return { ml: 7 };
                if (isXSLarge) return { ml: 5 };
                if (isXLarge) return { ml: 6 };
                if (isLarge) return { ml: 6 };
                if (isMedium) return { ml: 6 };
                if (isSmall) return { ml: 6 };
                return { ml: 6 };
            case "multi-select":
                if (is4K) return { height: "38px" };
                if (isXXLarge) return { height: "32px" };
                if (isXLarge) return { height: "25px", minHeight: "25px" };
                if (isLarge) return { height: "23px" };
                if (isMedium) return { height: "24px" };
                if (isSmall) return { height: "24px" };
                return { height: "24px" };
            default:
                return { height: "32px", fontSize: "80px" };
        }
    };

    return {
        getFontSize,
        getContainerWidth,
        getContainerHeight,
        getIconSize,
        getButtonStyle,
        getSectionStyle,
    };
};
